export default "__VITE_ASSET__z8sXJlXc__"